import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { EarnBreakdownCard } from "@hsbc/portal";
import styles from "./styles.module.scss";

// We hardcode these in IN for 2 reasons:
// - We don't have the promotions API response to use
// - Some BIN's have the same card name, so we can't use that
const hotelEarnList = {
  12: {
    cardNames: ["GPB Privé", "Premier"],
    rate: "12X",
  },
  6: {
    cardNames: ["TravelOne", "RuPay Platinum", "Visa Platinum"],
    rate: "6X",
  },
};

const flightEarnList = {
  6: {
    cardNames: ["GPB Privé", "Premier"],
    rate: "6X",
  },
  4: {
    cardNames: ["TravelOne", "RuPay Platinum", "Visa Platinum"],
    rate: "4X",
  },
};

const groundEarnList = {
  2: {
    cardNames: [
      "GPB Privé",
      "Premier",
      "TravelOne",
      "RuPay Platinum",
      "Visa Platinum",
    ],
    rate: "2X",
  },
};

export const PremierDestinationEarnDialog = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PremierDestinationEarnDialog");

  return (
    <div className={block}>
      <div className={cn("description-container")}>
        <span className={cn("description")}>
          <Trans
            i18nKey="premierDestinations.earnDialog.description"
            components={[<span className={cn("bold")} />]}
          />
        </span>

        <span className={cn("terms")}>
          {t("premierDestinations.earnDialog.termsAndConditions")}
        </span>
      </div>

      <span className={cn("title")}>
        <Trans
          i18nKey="premierDestinations.earnDialog.earnBreakdownTitle"
          components={[<span className={cn("bold")} />]}
        />
      </span>

      <EarnBreakdownCard earnList={hotelEarnList} title={t("hotels")} />

      <EarnBreakdownCard earnList={flightEarnList} title={t("flights")} />

      <EarnBreakdownCard
        earnList={groundEarnList}
        title={t("apac.cars.carRentals")}
      />
    </div>
  );
};
